import { defineStore } from "pinia";

export const useDashboardStore = defineStore('dashboard', {
    state: () => ({
        staleApplications: [],
        newApplications: [],
        interviewApplications: [],
        favoriteApplications: [],
        staleApplicationCount: 0,
        newApplicationCount: 0,
        interviewApplicationCount: 0,
        unconfirmedInterviewApplicationCount: 0,
        favoriteApplicationCount: 0,
        summary: [],
        fetching: {
            'applications': true,
            'applicationsCount': true,
            'summary': true,
        },
        activity: 'tasks',
        tmpSchedule: [],
        calendar: [],
    }),
    actions: {
        startFetching() {
            Object.keys(this.fetching).forEach((key) => {
                this.fetching[key] = true;
            });
        },
        endFetching(module) {
            this.fetching[module] = false;
        },
        set(data) {
            Object.entries(data).forEach(([type, item]) => {
                switch (type) {
                    case 'stale':
                        this.staleApplications = this.staleApplications.concat(item.applications);
                        break;
                    case 'new':
                        this.newApplications = this.newApplications.concat(item.applications);
                        break;
                    case 'interview':
                        this.interviewApplications = this.interviewApplications.concat(item.applications);
                        break;
                    case 'favorite':
                        this.favoriteApplications = this.favoriteApplications.concat(item.applications);
                        break;
                }
            });
        },
        setCount(data) {
            Object.entries(data).forEach(([type, item]) => {
                switch (type) {
                    case 'stale':
                        this.staleApplicationCount = item.count;
                        break;
                    case 'new':
                        this.newApplicationCount = item.count;
                        break;
                    case 'interview':
                        this.interviewApplicationCount = item.count;
                        break;
                    case 'unconfirmedInterview':
                        this.unconfirmedInterviewApplicationCount = item.count;
                        break;
                    case 'favorite':
                        this.favoriteApplicationCount = item.count;
                        break;
                }
            });
        },
        setSummary(data) {
            this.summary = data;
        },
        activityItem(data) {
            this.activity = data;
        },
        setCalendarEvents(eventArray) {
            this.calendar = eventArray;
        },
        resetState() {
            this.staleApplications = [];
            this.newApplications = [];
            this.interviewApplications = [];
            this.favoriteApplications = [];
        },
    },
});
